import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ProgressBar } from '..';
import { SearchModes, SearchStatus } from '../../constants';

const TripSearchProgressBar = () => {
  const [searchProgress, setSearchProgress] = useState(0);
  const [searchProgressInterval, setSearchProgressInterval] = useState(null);
  const tripSearchStatus = useSelector((state) => state.tripSearch.searchStatus);

  /// To make sure we don't show trip search spinner while get remaining itineraries
  const pollProgress = useSelector((state) => {
    if (state.tripSearch.selectedSearchMode === SearchModes.HOTEL) {
      return state.tripSearch.searchObj.hotel.searchProgress;
    } if (state.tripSearch.selectedSearchMode === SearchModes.FLIGHT) {
      return state.tripSearch.searchObj.flight.searchProgress;
    }
    return undefined;
  });

  useEffect(() => {
    if (tripSearchStatus === SearchStatus.DONE) {
      clearInterval(searchProgressInterval);
      setSearchProgressInterval(null);
      setSearchProgress(100);
      setTimeout(() => {
        setSearchProgress(0);
      }, 200);
    }
  }, [tripSearchStatus, searchProgressInterval]);

  useEffect(() => {
    if (tripSearchStatus === SearchStatus.SEARCHING && !searchProgressInterval) {
      let currentSearchProgress = 0;
      const interval = setInterval(() => {
        currentSearchProgress += 0.5;
        if (currentSearchProgress < 90) {
          setSearchProgress((prev) => prev + 0.5);
        }
      }, 50);
      setSearchProgressInterval(interval);
    }
    return () => {
      if (searchProgressInterval) {
        clearInterval(searchProgressInterval);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tripSearchStatus]);

  return (
    tripSearchStatus === SearchStatus.SEARCHING && pollProgress === undefined
      ? <ProgressBar progress={searchProgress} /> : <></>
  );
};

export default TripSearchProgressBar;
